<!--
Announcement - display some banner message here (from stt_applcnt_banner for a specified category)
@author cm359n
-->

<template>
  <div v-if="displayIt" >
      <slot></slot>
  </div>
  <div v-else>
      <slot name="alternate"></slot>
  </div>
</template>

<script setup>
//Utilities
import { ref, defineProps } from 'vue'
import * as lst from '@/components/localStorage.js'

const props = defineProps({
  name: String
})

//Data
let disp = false
const features = lst.getValue('featureList')
if (features.indexOf(props.name) != -1) {
  disp = true
}

const displayIt = ref(disp)

</script>
